export default __webpack_public_path__ + "static/media/exlogo.6861d739.png";